import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Municipio, ReportRequest } from '../../types';

export const fetchDatosIniciales = createAsyncThunk(
  'map/fetchDatosIniciales',
  async () => {
    const baseUrl = process.env.REACT_APP_API_URL;    
    const response = await fetch(`${baseUrl}/api/report`);
    if (!response.ok) throw new Error('Error al cargar datos de la API');
    return await response.json();
  }
);

export const enviarReporteProtesta = createAsyncThunk(
  'map/enviarReporteProtesta',
  async (request: ReportRequest) => { // <-- Tipado correcto aquí
    const baseUrl = process.env.REACT_APP_API_URL;    
    
    const response = await fetch(`${baseUrl}/api/report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request)
    });
    
    return await response.json();
  }
);

const initialState = [
    {
        id: 1,
        name: 'Isla de la Juventud',
        status: "regimen",
        reports: []
    },
    {
        id: 2,
        name: 'Maisí',
        status: "regimen",
        reports: []
    },
    {
        id: 3,
        name: 'Baracoa',
        status: "regimen",
        reports: []
    },
    {
        id: 4,
        name: 'Imías',
        status: "regimen",
        reports: []
    },
    {
        id: 5,
        name: 'Yateras',
        status: "regimen",
        reports: []
    },
    {
        id: 6,
        name: 'Manuel Tames',
        status: "regimen",
        reports: []
    },
    {
        id: 7,
        name: 'San Antonio del Sur',
        status: "regimen",
        reports: []
    },
    {
        id: 8,
        name: 'Guantánamo',
        status: "regimen",
        reports: []
    },
    {
        id: 9,
        name: 'El Salvador',
        status: "regimen",
        reports: []
    },
    {
        id: 10,
        name: 'Caimanera',
        status: "regimen",
        reports: []
    },
    {
        id: 11,
        name: 'Niceto Pérez',
        status: "regimen",
        reports: []
    },
    {
        id: 12,
        name: 'Contramaestre',
        status: "regimen",
        reports: []
    },
    {
        id: 13,
        name: 'Mella',
        status: "regimen",
        reports: []
    },
    {
        id: 14,
        name: 'San Luis',
        status: "regimen",
        reports: []
    },
    {
        id: 15,
        name: 'Segundo Frente',
        status: "regimen",
        reports: []
    },
    {
        id: 16,
        name: 'Songo La Maya',
        status: "regimen",
        reports: []
    },
    {
        id: 17,
        name: 'Palma Soriano',
        status: "regimen",
        reports: []
    },
    {
        id: 18,
        name: 'Tercer Frente',
        status: "regimen",
        reports: []
    },
    {
        id: 19,
        name: 'Santiago de Cuba',
        status: "regimen",
        reports: []
    },
    {
        id: 20,
        name: 'Guamá',
        status: "regimen",
        reports: []
    },
    {
        id: 21,
        name: 'Cauto Cristo',
        status: "regimen",
        reports: []
    },
    {
        id: 22,
        name: 'Río Cauto',
        status: "regimen",
        reports: []
    },
    {
        id: 23,
        name: 'Bayamo',
        status: "regimen",
        reports: []
    },
    {
        id: 24,
        name: 'Yara',
        status: "regimen",
        reports: []
    },
    {
        id: 25,
        name: 'Manzanillo',
        status: "regimen",
        reports: []
    },
    {
        id: 26,
        name: 'Campechuela',
        status: "regimen",
        reports: []
    },
    {
        id: 27,
        name: 'Media Luna',
        status: "regimen",
        reports: []
    },
    {
        id: 28,
        name: 'Jiguaní',
        status: "regimen",
        reports: []
    },
    {
        id: 29,
        name: 'Guisa',
        status: "regimen",
        reports: []
    },
    {
        id: 30,
        name: 'Buey Arriba',
        status: "regimen",
        reports: []
    },
    {
        id: 31,
        name: 'Bartolomé Masó',
        status: "regimen",
        reports: []
    },
    {
        id: 32,
        name: 'Pilón',
        status: "regimen",
        reports: []
    },
    {
        id: 33,
        name: 'Niquero',
        status: "regimen",
        reports: []
    },
    {
        id: 34,
        name: 'Báguanos',
        status: "regimen",
        reports: []
    },
    {
        id: 35,
        name: 'Rafael Freire',
        status: "regimen",
        reports: []
    },
    {
        id: 36,
        name: 'Banes',
        status: "regimen",
        reports: []
    },
    {
        id: 37,
        name: 'Antilla',
        status: "regimen",
        reports: []
    },
    {
        id: 38,
        name: 'Frank País',
        status: "regimen",
        reports: []
    },
    {
        id: 39,
        name: 'Moa',
        status: "regimen",
        reports: []
    },
    {
        id: 40,
        name: 'Sagua de Tánamo',
        status: "regimen",
        reports: []
    },
    {
        id: 41,
        name: 'Mayarí',
        status: "regimen",
        reports: []
    },
    {
        id: 42,
        name: 'Cueto',
        status: "regimen",
        reports: []
    },
    {
        id: 43,
        name: 'Urbano Noris',
        status: "regimen",
        reports: []
    },
    {
        id: 44,
        name: 'Cacocum',
        status: "regimen",
        reports: []
    },
    {
        id: 45,
        name: 'Gibara',
        status: "regimen",
        reports: []
    },
    {
        id: 46,
        name: 'Holguín',
        status: "regimen",
        reports: []
    },
    {
        id: 47,
        name: 'Calixto García',
        status: "regimen",
        reports: []
    },
    {
        id: 48,
        name: 'Manatí',
        status: "regimen",
        reports: []
    },
    {
        id: 49,
        name: 'Puerto Padre',
        status: "regimen",
        reports: []
    },
    {
        id: 50,
        name: 'Jesús Menéndez',
        status: "regimen",
        reports: []
    },
    {
        id: 51,
        name: 'Majibacoa',
        status: "regimen",
        reports: []
    },
    {
        id: 52,
        name: 'Las Tunas',
        status: "regimen",
        reports: []
    },
    {
        id: 53,
        name: 'Jobabo',
        status: "regimen",
        reports: []
    },
    {
        id: 54,
        name: 'Colombia',
        status: "regimen",
        reports: []
    },
    {
        id: 55,
        name: 'Amancio',
        status: "regimen",
        reports: []
    },
    {
        id: 56,
        name: 'Nuevitas',
        status: "regimen",
        reports: []
    },
    {
        id: 57,
        name: 'Minas',
        status: "regimen",
        reports: []
    },
    {
        id: 58,
        name: 'Sierra de Cubitas',
        status: "regimen",
        reports: []
    },
    {
        id: 59,
        name: 'Esmeralda',
        status: "regimen",
        reports: []
    },
    {
        id: 60,
        name: 'Céspedes',
        status: "regimen",
        reports: []
    },
    {
        id: 61,
        name: 'Camagüey',
        status: "regimen",
        reports: []
    },
    {
        id: 62,
        name: 'Jimaguayú',
        status: "regimen",
        reports: []
    },
    {
        id: 63,
        name: 'Sibanicú',
        status: "regimen",
        reports: []
    },
    {
        id: 64,
        name: 'Guáimaro',
        status: "regimen",
        reports: []
    },
    {
        id: 65,
        name: 'Najasa',
        status: "regimen",
        reports: []
    },
    {
        id: 66,
        name: 'Santa Cruz del Sur',
        status: "regimen",
        reports: []
    },
    {
        id: 67,
        name: 'Vertientes',
        status: "regimen",
        reports: []
    },
    {
        id: 68,
        name: 'Florida',
        status: "regimen",
        reports: []
    },
    {
        id: 69,
        name: 'Chambas',
        status: "regimen",
        reports: []
    },
    {
        id: 70,
        name: 'Morón',
        status: "regimen",
        reports: []
    },
    {
        id: 71,
        name: 'Florencia',
        status: "regimen",
        reports: []
    },
    {
        id: 72,
        name: 'Ciro Redondo',
        status: "regimen",
        reports: []
    },
    {
        id: 73,
        name: 'Ciego de Ávila',
        status: "regimen",
        reports: []
    },
    {
        id: 74,
        name: 'Majagua',
        status: "regimen",
        reports: []
    },
    {
        id: 75,
        name: 'Venezuela',
        status: "regimen",
        reports: []
    },
    {
        id: 76,
        name: 'Bolivia',
        status: "regimen",
        reports: []
    },
    {
        id: 77,
        name: 'Primero de Enero',
        status: "regimen",
        reports: []
    },
    {
        id: 78,
        name: 'Baraguá',
        status: "regimen",
        reports: []
    },
    {
        id: 79,
        name: 'Cabaiguán',
        status: "regimen",
        reports: []
    },
    {
        id: 80,
        name: 'Fomento',
        status: "regimen",
        reports: []
    },
    {
        id: 81,
        name: 'Yaguajay',
        status: "regimen",
        reports: []
    },
    {
        id: 82,
        name: 'Taguasco',
        status: "regimen",
        reports: []
    },
    {
        id: 83,
        name: 'Jatibonico',
        status: "regimen",
        reports: []
    },
    {
        id: 84,
        name: 'La Sierpe',
        status: "regimen",
        reports: []
    },
    {
        id: 85,
        name: 'Sancti Spíritus',
        status: "regimen",
        reports: []
    },
    {
        id: 86,
        name: 'Trinidad',
        status: "regimen",
        reports: []
    },
    {
        id: 87,
        name: 'Encrucijada',
        status: "regimen",
        reports: []
    },
    {
        id: 88,
        name: 'Camajuaní',
        status: "regimen",
        reports: []
    },
    {
        id: 89,
        name: 'Cifuentes',
        status: "regimen",
        reports: []
    },
    {
        id: 90,
        name: 'Sagua La Grande',
        status: "regimen",
        reports: []
    },
    {
        id: 91,
        name: 'Quemado de Güines',
        status: "regimen",
        reports: []
    },
    {
        id: 92,
        name: 'Corralillo',
        status: "regimen",
        reports: []
    },
    {
        id: 93,
        name: 'Santo Domingo',
        status: "regimen",
        reports: []
    },
    {
        id: 94,
        name: 'Santa Clara',
        status: "regimen",
        reports: []
    },
    {
        id: 95,
        name: 'Ranchuelo',
        status: "regimen",
        reports: []
    },
    {
        id: 96,
        name: 'Caibarién',
        status: "regimen",
        reports: []
    },
    {
        id: 97,
        name: 'Remedios',
        status: "regimen",
        reports: []
    },
    {
        id: 98,
        name: 'Placetas',
        status: "regimen",
        reports: []
    },
    {
        id: 99,
        name: 'Manicaragua',
        status: "regimen",
        reports: []
    },
    {
        id: 100,
        name: 'Lajas',
        status: "regimen",
        reports: []
    },
    {
        id: 101,
        name: 'Rodas',
        status: "regimen",
        reports: []
    },
    {
        id: 102,
        name: 'Palmira',
        status: "regimen",
        reports: []
    },
    {
        id: 103,
        name: 'Cruces',
        status: "regimen",
        reports: []
    },
    {
        id: 104,
        name: 'Cumanayagua',
        status: "regimen",
        reports: []
    },
    {
        id: 105,
        name: 'Cienfuegos',
        status: "regimen",
        reports: []
    },
    {
        id: 106,
        name: 'Abreus',
        status: "regimen",
        reports: []
    },
    {
        id: 107,
        name: 'Aguada de Pasajeros',
        status: "regimen",
        reports: []
    },
    {
        id: 108,
        name: 'Jovellanos',
        status: "regimen",
        reports: []
    },
    {
        id: 109,
        name: 'Pedro Betancourt',
        status: "regimen",
        reports: []
    },
    {
        id: 110,
        name: 'Jagüey Grande',
        status: "regimen",
        reports: []
    },
    {
        id: 111,
        name: 'Perico',
        status: "regimen",
        reports: []
    },
    {
        id: 112,
        name: 'Colón',
        status: "regimen",
        reports: []
    },
    {
        id: 113,
        name: 'Martí',
        status: "regimen",
        reports: []
    },
    {
        id: 114,
        name: 'Los Arabos',
        status: "regimen",
        reports: []
    },
    {
        id: 115,
        name: 'Calimete',
        status: "regimen",
        reports: []
    },
    {
        id: 116,
        name: 'Cárdenas',
        status: "regimen",
        reports: []
    },
    {
        id: 117,
        name: 'Matanzas',
        status: "regimen",
        reports: []
    },
    {
        id: 118,
        name: 'Limonar',
        status: "regimen",
        reports: []
    },
    {
        id: 119,
        name: 'Unión de Reyes',
        status: "regimen",
        reports: []
    },
    {
        id: 120,
        name: 'Ciénaga de Zapata',
        status: "regimen",
        reports: []
    },
    {
        id: 121,
        name: 'Nueva Paz',
        status: "regimen",
        reports: []
    },
    {
        id: 122,
        name: 'San Nicolás',
        status: "regimen",
        reports: []
    },
    {
        id: 123,
        name: 'Güines',
        status: "regimen",
        reports: []
    },
    {
        id: 124,
        name: 'Madruga',
        status: "regimen",
        reports: []
    },
    {
        id: 125,
        name: 'Santa Cruz del Norte',
        status: "regimen",
        reports: []
    },
    {
        id: 126,
        name: 'Jaruco',
        status: "regimen",
        reports: []
    },
    {
        id: 127,
        name: 'San José de las Lajas',
        status: "regimen",
        reports: []
    },
    {
        id: 128,
        name: 'Melena del Sur',
        status: "regimen",
        reports: []
    },
    {
        id: 129,
        name: 'Batabanó',
        status: "regimen",
        reports: []
    },
    {
        id: 131,
        name: 'Bejucal',
        status: "regimen",
        reports: []
    },
    {
        id: 132,
        name: 'Quivicán',
        status: "regimen",
        reports: []
    },
    {
        id: 133,
        name: 'Regla',
        status: "regimen",
        reports: []
    },
    {
        id: 134,
        name: 'La Habana Vieja',
        status: "regimen",
        reports: []
    },
    {
        id: 135,
        name: 'Centro Habana',
        status: "regimen",
        reports: []
    },
    {
        id: 136,
        name: 'Cerro',
        status: "regimen",
        reports: []
    },
    {
        id: 137,
        name: 'Plaza de la Revolución',
        status: "regimen",
        reports: []
    },
    {
        id: 138,
        name: 'Marianao',
        status: "regimen",
        reports: []
    },
    {
        id: 139,
        name: 'Diez de Octubre',
        status: "regimen",
        reports: []
    },
    {
        id: 140,
        name: 'San Miguel del Padrón',
        status: "regimen",
        reports: []
    },
    {
        id: 141,
        name: 'Habana del Este',
        status: "regimen",
        reports: []
    },
    {
        id: 142,
        name: 'Guanabacoa',
        status: "regimen",
        reports: []
    },
    {
        id: 143,
        name: 'Cotorro',
        status: "regimen",
        reports: []
    },
    {
        id: 144,
        name: 'Arroyo Naranjo',
        status: "regimen",
        reports: []
    },
    {
        id: 145,
        name: 'Boyeros',
        status: "regimen",
        reports: []
    },
    {
        id: 146,
        name: 'La Lisa',
        status: "regimen",
        reports: []
    },
    {
        id: 147,
        name: 'Playa',
        status: "regimen",
        reports: []
    },
    {
        id: 148,
        name: 'Güira de Melena',
        status: "regimen",
        reports: []
    },
    {
        id: 149,
        name: 'San Antonio de los Baños',
        status: "regimen",
        reports: []
    },
    {
        id: 150,
        name: 'Bauta',
        status: "regimen",
        reports: []
    },
    {
        id: 151,
        name: 'Alquízar',
        status: "regimen",
        reports: []
    },
    {
        id: 152,
        name: 'Caimito',
        status: "regimen",
        reports: []
    },
    {
        id: 153,
        name: 'Guanajay',
        status: "regimen",
        reports: []
    },
    {
        id: 154,
        name: 'Artemisa',
        status: "regimen",
        reports: []
    },
    {
        id: 155,
        name: 'Mariel',
        status: "regimen",
        reports: []
    },
    {
        id: 156,
        name: 'Candelaria',
        status: "regimen",
        reports: []
    },
    {
        id: 157,
        name: 'Bahía Honda',
        status: "regimen",
        reports: []
    },
    {
        id: 158,
        name: 'San Cristobal',
        status: "regimen",
        reports: []
    },
    {
        id: 159,
        name: 'La Palma',
        status: "regimen",
        reports: []
    },
    {
        id: 160,
        name: 'Viñales',
        status: "regimen",
        reports: []
    },
    {
        id: 161,
        name: 'Los Palacios',
        status: "regimen",
        reports: []
    },
    {
        id: 162,
        name: 'Consolación del Sur',
        status: "regimen",
        reports: []
    },
    {
        id: 163,
        name: 'Pinar del Río',
        status: "regimen",
        reports: []
    },
    {
        id: 164,
        name: 'San Luis',
        status: "regimen",
        reports: []
    },
    {
        id: 165,
        name: 'San Juan y Martínez',
        status: "regimen",
        reports: []
    },
    {
        id: 166,
        name: 'Minas de Matahambre',
        status: "regimen",
        reports: []
    },
    {
        id: 167,
        name: 'Mantua',
        status: "regimen",
        reports: []
    },
    {
        id: 168,
        name: 'Guane',
        status: "regimen",
        reports: []
    },
    {
        id: 169,
        name: 'Sandino',
        status: "regimen",
        reports: []
    }
] as Municipio[]

export const mapSlice = createSlice({
    name: 'map',
    initialState: {
                    items: [],
                    loading: false,
                    error: null
                  },
    reducers:{
        actualizarDocumentoPorWebSocket: (state, action) => {
          const documentoModificado = action.payload;
          
          const municipio = state.items.find(m => m.id === documentoModificado._id);        
          if(municipio){
            municipio.status = documentoModificado.Status
            municipio.reports = documentoModificado.Reports.map(r => ({
                deviceId: r.DeviceId,
                location: r.Location,
                mediaLink: r?.MediaLink
            }))
          }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDatosIniciales.pending, (state) => {
            state.loading = true;
            })
            .addCase(fetchDatosIniciales.fulfilled, (state, action) => {
            state.loading = false;
            state.items = action.payload;
            })
            .addCase(fetchDatosIniciales.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.items = []
            });
    }
})

export const { actualizarDocumentoPorWebSocket } = mapSlice.actions

export default mapSlice.reducer